import {
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import {firestore} from "../plugins/firebase";
import {logToolAccessChange} from "./activityLogger";

export async function setToolUserAccess({
  toolId,
  toolName,
  uid,
  accessGranted,
  requiredClaim = null,
  userEmail,
  userName,
}) {
  if (!toolId || !uid) {
    throw new Error("setToolUserAccess requires toolId and uid");
  }

  if (accessGranted) {
    await updateDoc(doc(firestore, "tools", toolId), {
      users: arrayUnion(uid),
    });

    if (requiredClaim?.key) {
      await setDoc(doc(firestore, "tools", toolId, "claims", uid), {
        [requiredClaim.key]: requiredClaim.value,
      });
    }
  } else {
    await updateDoc(doc(firestore, "tools", toolId), {
      users: arrayRemove(uid),
    });
    await deleteDoc(doc(firestore, "tools", toolId, "claims", uid));
  }

  await logToolAccessChange(
    userEmail || uid,
    userName || uid,
    toolId,
    toolName || toolId,
    accessGranted
  );
}